module.exports = {
      id: "premium-usage",
      viewBox: "0 0 576 512",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#premium",
      toString: function () {
        return this.url;
      }
    }